import React, { useEffect, useRef, useState } from 'react';
import { MdWhatsapp } from 'react-icons/md';

import { LuPhone } from 'react-icons/lu';
import { toast } from 'react-toastify';
import { ShopDTO } from '../../DTO/shopResponseDTO';
import { redirectToWhatsapp } from '../../helpers/utils';
import {
    CartValuesServiceStore
} from '../../store/shoppingCart/shoppingCartStore';
import { BigButton } from '../BigButton';
import { HeadItemAddToCart } from '../HeadItemAddToCart';
import ReactIcon from '../ReactIcon';
import {
    CardActions,
    CardContent,
    CardDescription,
    CardTitle,
    CardWrapper,
    WhatsButtonSingle,
} from './styles';

interface CardItemProps {
    id: string;
    imageUrl: string;
    IconComponent: React.ComponentType;
    title: string;
    description: string;
    value: number;
    date: Date;
    handleAddToCart: (cartCurrentValue: CartValuesServiceStore, accessProfile: string) => void;
    information1: string;
    item: ShopDTO;
}

export const ItemAddToCart: React.FC<CardItemProps> = ({
    imageUrl,
    IconComponent,
    title,
    description,
    item,
}) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const information2Number = item.information2.replace(/\D/g, '');
    const [buttonText, setButtonText] = useState(item.information2);

    const handleRedirectPhone = async () => {
        await navigator.clipboard.writeText(information2Number);
        toast.success('Telefone copiado para a área de transferência!');
        setButtonText('Telefone copiado!');

        timeoutRef.current = setTimeout(() => {
            setButtonText(item.information2);
        }, 1000);
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleRedirectWhatsapp = () => {
        window.open(`https://wa.me/${information2Number}`, '_blank')?.focus();
    };

    return (
        <CardWrapper>
            <HeadItemAddToCart
                imageUrl={imageUrl}
                IconComponent={IconComponent}
            />
            <CardContent>
                <CardTitle>{title}</CardTitle>
                <CardDescription title={description}>
                    {description}
                </CardDescription>
            </CardContent>
            <CardActions>
                {information2Number && (
                    <>
                        <BigButton
                            bgColor="primary"
                            color="primary"
                            allWidth={true}
                            onClick={handleRedirectPhone}
                        >
                            <ReactIcon
                                Icon={LuPhone}
                                size={'1.2rem'}
                                fill="1"
                                strokeWidth={0.9}
                            />
                            {buttonText}
                        </BigButton>
                        <WhatsButtonSingle
                            title={`Whatsapp, ${title}`}
                            onClick={handleRedirectWhatsapp}
                        >
                            <ReactIcon
                                Icon={MdWhatsapp}
                                size={'1.5rem'}
                                onClick={() => redirectToWhatsapp(title)}
                            />
                        </WhatsButtonSingle>
                    </>
                )}
            </CardActions>
        </CardWrapper>
    );
};
